import React, { memo } from 'react';

// import DescriptionIcon from '@material-ui/icons/Description';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { truncateText } from 'helpers/truncateText';

import { useStyles } from './styles';

const FileListComponent = ({ files, handleRemoveFile, handleClean, handleChooseFileClick }) => {
  const classes = useStyles();

  return (
    <>
      {/* <ul className={classes.fileList}>
        {Array.from(files).map((file, index) => (
          <li className={classes.fileItem} key={file.name}>
            <DescriptionIcon className={classes.fileIcon} color='primary' />

            {truncateText(file.name || '', 40)}
          </li>
        ))}
      </ul> */}

      {/* <Button variant='text' size='small' onClick={handleClean}>
          Limpar
        </Button> */}
      <CheckCircleIcon align='center' style={{ fill: '#58E732 ', fontSize: 60 }}></CheckCircleIcon>
    </>
  );
};

export const FileList = memo(FileListComponent);
